import { render } from "./AuthPoweredBy.vue?vue&type=template&id=6b43a387&scoped=true"
import script from "./AuthPoweredBy.vue?vue&type=script&lang=js"
export * from "./AuthPoweredBy.vue?vue&type=script&lang=js"

import "./AuthPoweredBy.vue?vue&type=style&index=0&id=6b43a387&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b43a387"]])

export default __exports__